import { createReducer } from 'typesafe-actions';
import { CurrentStep } from '../../../constants/constants';
import { validateSystemSettingsLocalStorage } from '../../../helpers/validateLocalStorage';
import {
  _updateCurrentRoute,
  _updateSystemSettingsAction,
  _updateUtmSource,
} from '../../actions/system';

export interface SystemState {
  utmSource: string;
  currentStep: CurrentStep;
  currentRoute: string;
  error: string | null;
}

const localStorageData = validateSystemSettingsLocalStorage();

const initialState = {
  currentStep: CurrentStep.StartApplication, // seems like we dont really use it
  currentRoute: '',
  error: null,
  utmSource: '',
  ...(localStorageData || {}),
};

export const systemReducer = createReducer<SystemState>(initialState)
  .handleAction(
    _updateSystemSettingsAction,
    (
      state: SystemState,
      action: ReturnType<typeof _updateSystemSettingsAction>,
    ): SystemState => ({
      ...state,
      ...action.payload,
    }),
  )
  .handleAction(
    _updateCurrentRoute,
    (
      state: SystemState,
      action: ReturnType<typeof _updateCurrentRoute>,
    ): SystemState => ({
      ...state,
      currentRoute: action.payload,
    }),
  )
  .handleAction(
    _updateUtmSource,
    (
      state: SystemState,
      action: ReturnType<typeof _updateUtmSource>,
    ): SystemState => ({
      ...state,
      utmSource: action.payload,
    }),
  );
